import { MembershipPackageRecurring } from 'common/interfaces/api';
import {
  COIN_POLICY,
  MEMBERSHIP_50_PERCENT_DISCOUNT_HELP_URL,
  MEMBERSHIP_HELP_LINK,
  MEMBERSHIP_POLICY_LINK,
  POLICY_URL,
  PRIME_AND_MEMBERSHIP_DIFF_HELP_URL,
  PRIME_SUB_HELP_URL,
  USER_TERM_URL,
  YEAR_START_2025_EVENT_HELP_URL,
} from 'common/utils';
import { getUserYearStartEvent } from 'common/utils/user';
import { EXPRESS_CHECKOUT_PAYMENT_METHOD_WARNING } from 'components/common/StripeExpressCheckout/warningText';
import { useContext } from 'react';
import useStore from 'store/timeline';

import { MembershipPaymentSectionContext } from '..';
import styles from './PolicyDescription.module.scss';

const PolicyDescription = (): JSX.Element => {
  const { currentPaymentBy, membershipPackages } = useContext(
    MembershipPaymentSectionContext,
  );
  const currentUser = useStore((state) => state.currentUser);
  const discountMembershipEvent = getUserYearStartEvent(currentUser);
  const showsMonthlyDiscountCampaignNote =
    currentPaymentBy === 'credit' &&
    membershipPackages?.some(
      (pack) =>
        pack.recurring === MembershipPackageRecurring.Month &&
        pack.discounted_percentage === 50,
    );

  return (
    <ul className={styles.smallPrint}>
      <li>コイン支払いでご登録の場合、無料体験はご利用いただけません。</li>
      <li>
        メンバーシップ登録を行うと、
        <a
          className={styles.link}
          href={MEMBERSHIP_POLICY_LINK}
          target="_blank"
          rel="noopener"
        >
          メンバーシップポリシー
        </a>
        、
        <a
          className={styles.link}
          href={USER_TERM_URL}
          target="_blank"
          rel="noopener"
        >
          利用規約
        </a>
        、
        <a
          className={styles.link}
          href={POLICY_URL}
          target="_blank"
          rel="noopener"
        >
          プライバシーポリシー
        </a>
        {currentPaymentBy === 'coin' && (
          <>
            、
            <a
              className={styles.link}
              href={COIN_POLICY}
              target="_blank"
              rel="noopener"
            >
              PostPrime Coinポリシー
            </a>
          </>
        )}
        に同意したことになります。
      </li>
      {currentPaymentBy === 'credit' && (
        <li>
          メンバーシップ無料体験中に契約した「長期プライム登録」は、新規WEBプライム登録の割引特典の対象外です。
        </li>
      )}
      <li>
        <a className={styles.link} href={PRIME_SUB_HELP_URL} target="_blank">
          プライム登録
        </a>
        と
        <a className={styles.link} href={MEMBERSHIP_HELP_LINK} target="_blank">
          メンバーシップ登録
        </a>
        の違いについては
        <a
          className={styles.link}
          href={PRIME_AND_MEMBERSHIP_DIFF_HELP_URL}
          target="_blank"
        >
          こちら
        </a>
        。
      </li>
      {!!discountMembershipEvent && (
        <li>
          <span className={styles.highlight}>
            本キャンペーンの割引対象期間は、登録から3カ月間となります。割引対象期間経過後は、通常価格での支払いとなります。
          </span>
          割引キャンペーンはコイン支払いの対象外です。キャンペーンについての詳細は
          <a
            className={styles.link}
            href={YEAR_START_2025_EVENT_HELP_URL}
            target="_blank"
          >
            こちら
          </a>
          をご確認ください。
        </li>
      )}
      {currentPaymentBy === 'credit' && (
        <li>{EXPRESS_CHECKOUT_PAYMENT_METHOD_WARNING}</li>
      )}
      {showsMonthlyDiscountCampaignNote && (
        <li>
          メンバーシップ登録50％割引キャンペーンの対象は、新規でWebより月額プランをご登録された方限定となります。割引期間は登録後3か月間です。割引期間終了後は、通常価格での支払となります。（キャンペーン詳細は
          <a
            className={styles.link}
            href={MEMBERSHIP_50_PERCENT_DISCOUNT_HELP_URL}
            target="_blank"
            rel="noopener"
          >
            こちら
          </a>
          よりご確認ください。）
        </li>
      )}
    </ul>
  );
};

export default PolicyDescription;
